// When running on localhost, always use local Strapi and skip runtime config.
const _isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// Prefer a runtime-injected configuration (window.__RUNTIME_CONFIG__),
// then environment variable `REACT_APP_API_URL`, then fallback to localhost.
const runtimeConfig = (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) ? window.__RUNTIME_CONFIG__ : {};

const API_URL = _isLocalhost
  ? 'http://localhost:1337'
  : (runtimeConfig.API_URL || process.env.REACT_APP_API_URL || 'http://localhost:1337');

// API_BASE is API_URL without a trailing slash to make safe path joins
const API_BASE = typeof API_URL === 'string' ? API_URL.replace(/\/$/, '') : API_URL;

// Check-in max distance (metres). Priority: runtime-config -> REACT_APP_ env -> default 500.
const rawCheckin = runtimeConfig.CHECKIN_MAX_DISTANCE_METERS ?? process.env.REACT_APP_CHECKIN_MAX_DISTANCE_METERS;
const parsedCheckin = Number(rawCheckin);
const CHECKIN_MAX_DISTANCE_METERS = Number.isFinite(parsedCheckin) && parsedCheckin >= 0 ? Math.floor(parsedCheckin) : 500;

// Point rewards: runtime-config -> REACT_APP_ env -> defaults
const rawCheckinReward = runtimeConfig.CHECKIN_POINT_REWARD ?? process.env.REACT_APP_CHECKIN_POINT_REWARD;
const parsedCheckinReward = Number(rawCheckinReward);
const CHECKIN_POINT_REWARD = Number.isFinite(parsedCheckinReward) ? Math.floor(parsedCheckinReward) : 10;

const rawPhotoReward = runtimeConfig.PHOTO_POINT_REWARD ?? process.env.REACT_APP_PHOTO_POINT_REWARD;
const parsedPhotoReward = Number(rawPhotoReward);
const PHOTO_POINT_REWARD = Number.isFinite(parsedPhotoReward) ? Math.floor(parsedPhotoReward) : 5;

// Mapbox & Google client id: priority runtime-config -> REACT_APP_ -> empty
const rawMapbox = runtimeConfig.MAPBOX_ACCESS_TOKEN ?? process.env.REACT_APP_MAPBOX_ACCESS_TOKEN ?? '';
const MAPBOX_ACCESS_TOKEN = (typeof rawMapbox === 'string' && rawMapbox.trim() !== '') ? rawMapbox : '';

const rawGoogleClient = runtimeConfig.GOOGLE_CLIENT_ID ?? process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';
const GOOGLE_CLIENT_ID = (typeof rawGoogleClient === 'string' && rawGoogleClient.trim() !== '') ? rawGoogleClient : '';

const config = {
  API_URL,
  API_BASE,
  CHECKIN_MAX_DISTANCE_METERS,
  CHECKIN_POINT_REWARD,
  PHOTO_POINT_REWARD,
  MAPBOX_ACCESS_TOKEN,
  GOOGLE_CLIENT_ID,
};

export default config;
